<template>
  <div style="height: 100%">
    <grid ref="myGrid" :gridConfigUrl="gridConfigUrl">
      <template slot="lastHeaderColumns" slot-scope="props">
        <grid-table-th
          v-if="props.magicalMenuCodes.includes('sms-detail')"
          width="80px"
        >短信内容
        </grid-table-th>
      </template>
      <template slot="lastBodyColumns" slot-scope="props">
        <grid-table-td
          v-if="props.magicalMenuCodes.includes('sms-detail')"
          @click.native="handle(props.row)"
          width="80px"
        >查看
        </grid-table-td>
      </template>
    </grid>
    <whaty-dialog
      title="短信内容"
      :visible.sync="dialogVisible"
      width="400px"
      top="32vh">
      <div class="popup-wrap" slot="body">
        <div class="popup-body">
          <div class="el-dialog__body whaty-dialog-content">
            <span v-html="content"></span>
          </div>
          <div class="popup-foot group" style="padding-right: 0;">
            <a href="javascript:" class="btn btn-solid-primary" @click="dialogVisible = false">确定</a>
          </div>
        </div>
      </div>
    </whaty-dialog>
  </div>
</template>
<script>
import Grid from '../../../../components/grid/grid'
import GridTableTh from '../../../../components/grid-menu/grid-table-th'
import GridTableTd from '../../../../components/grid-menu/grid-table-td'
import GridTopMenu from '../../../../components/grid-menu/grid-top-menu'
import util from '../../../../libs/util'
import WhatyDialog from '../../../../components/dialog/dialog'

export default {
  components: {
    GridTopMenu,
    GridTableTd,
    GridTableTh,
    Grid,
    WhatyDialog
  },
  name: 'sms-send-record-vo',
  data() {
    return {
      gridConfigUrl: '',
      dialogVisible: false,
      content: ''
    }
  },
  created() {
    this.gridConfigUrl = this.$route.meta.url
  },
  methods: {
    handle(data) {
      if (data.detailFlag) {
        if (data.detail) {
          this.showSmsDetail(data.detail, data.wordCount, data.chargeCount)
        } else {
          this.$notify.error({title: '短信查看', message: '该条记录无短信内容'})
        }
      } else {
        // 调用接口查询
        util.ajax.get('/entity/notification/smsTaskRecord/detail/' + data.taskId).then(res => {
          if (res.data.success && res.data.data.detail) {
            this.showSmsDetail(res.data.data.detail, res.data.data.wordCount, res.data.data.chargeCount)
          } else {
            this.$notify.error({title: '短信查看', message: '该条记录无短信内容'})
          }
        }).catch(err => {
          this.$notify.error({title: '错误', message: '获取短信内容失败！'})
          console.error(err)
        })
      }
    },
    showSmsDetail(smsContent, wordCount, chargeCount) {
      this.dialogVisible = true
      this.content = smsContent + '<br><br>字数：' + wordCount + '字|' + chargeCount + '条计费'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/custom/components/grid/notification/sms-send-record-vo.vue